import React, { Fragment, ReactNode } from "react";
import { useInfiniteScroll } from "../../hooks/use-infinite-scroll";

interface IInfiniteScrollProps {
    onLoadMore: (page: number) => void;
    hasMore?: boolean;
    rootMargin?: number;
    children: ReactNode;
}

export const InfiniteScroll = (props: IInfiniteScrollProps) => {
    const sentinelRef = useInfiniteScroll<HTMLDivElement>({
        onLoadMore: props.onLoadMore,
        hasMore: props.hasMore,
        rootMargin: props.rootMargin ?? 500,
    });

    return <Fragment>
        {props.children}
        <div ref={sentinelRef} style={{ height: "1px" }} />
    </Fragment>;
};
